import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { DashboardLayout } from "@/components/Dashboard/DashboardLayout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import MaterialInventory from "./MaterialInventory";
import RawMaterials from "./RawMaterials";
import { MaterialTraceability } from "@/components/Inventory/MaterialTraceability";

export default function MaterialsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedTab = useMemo(() => {
    const value = searchParams.get("tab");
    return value === "raw" ? "raw" : "inventory";
  }, [searchParams]);
  const [activeTab, setActiveTab] = useState(requestedTab);

  useEffect(() => {
    setActiveTab(requestedTab);
  }, [requestedTab]);

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    if (value === "raw") {
      setSearchParams({ tab: "raw" });
    } else {
      setSearchParams({});
    }
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Materiales</h1>
          <p className="text-muted-foreground mt-1">
            Inventario de materiales y materias primas en un solo apartado
          </p>
        </div>

        <Tabs value={activeTab} onValueChange={handleTabChange} className="space-y-4">
          <TabsList className="flex flex-wrap">
            <TabsTrigger value="inventory">Materiales Laminación</TabsTrigger>
            <TabsTrigger value="raw">Materias Primas</TabsTrigger>
            <TabsTrigger value="trace">Trazabilidad</TabsTrigger>
          </TabsList>

          <TabsContent value="inventory" className="space-y-4">
            <MaterialInventory embedded />
          </TabsContent>

          <TabsContent value="raw" className="space-y-4">
            <RawMaterials embedded />
          </TabsContent>

          <TabsContent value="trace" className="space-y-4">
            <MaterialTraceability />
          </TabsContent>
        </Tabs>
      </div>
    </DashboardLayout>
  );
}
